import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizeDatePipe } from './localize-date-pipe.pipe';



@NgModule({
  declarations: [LocalizeDatePipe],
  imports: [
    CommonModule
  ],
  exports: [LocalizeDatePipe]
})
export class LocalizeDateModule { }
